<form [formGroup]="questionnaireForm" data-testid="questionnaire-form">
  <!-- Main Questions -->
  <div *ngFor="let question of mainQuestions; let mainIndex = index;" class="question mb-4">
    <ng-container [ngTemplateOutlet]="questionTemplate" 
                  [ngTemplateOutletContext]="{question: question, questionId: question.id}">
    </ng-container>
    
    <!-- Sub-questions for this main question -->
    <div *ngFor="let subQuestion of getSubQuestions(question.id)" class="question mb-4">
      <ng-container [ngTemplateOutlet]="questionTemplate" 
                    [ngTemplateOutletContext]="{question: subQuestion, questionId: subQuestion.id}">
      </ng-container>
    </div>
  </div>

  <!-- Question Template -->
  <ng-template #questionTemplate let-question="question" let-questionId="questionId">
    <lds-card data-testid="question-card">
      <div class="row">
        <div class="col question__label">
          {{ question.label }}
        </div>

        <div class="question__answer" [ngClass]="{'col-6': isLg, 'col-4': isSm}" data-testid="question-answer">
          <ng-container *ngIf="editMode">
            <div class="row">

              <ng-container *ngIf="question.questionType | isSingleChoice">
                <div class="col">
                  <lds-select [formControlName]="question.id | formControlIndex:questionIdToFormIndex | questionName"
                    [options]="getSelectListOptions(question.label) | ldsSelectOption"
                    [config]="{valueProperty: 'value', labelProperty: 'label'}">
                  </lds-select>
                </div>
              </ng-container>

              <ng-container *ngIf="question.questionType | isMultipleChoice">
                <div class="col">
                  <div class="question__checkbox-options mb-3" [formArrayName]="question.id | formControlIndex:questionIdToFormIndex | questionName"
                    *ngFor="let option of question.options; let choiceNumber = index;">
                    <lds-checkbox [formControlName]="choiceNumber"
                      [name]="question.id | formControlIndex:questionIdToFormIndex | checkboxName:choiceNumber" [label]="option.choice">
                    </lds-checkbox>
                  </div>
                </div>
              </ng-container>
              
              <ng-container *ngIf="hasViolation(question.id)">
                <div class="col-auto">
                  <lds-icon name="warning" appearance="warning"></lds-icon>
                </div>
              </ng-container>
            </div>

            <div *ngIf="isAdditionalInformationRequired(question)" class="row additional-information">
              <div class="col">
                <lds-text-area [formControlName]="question.id | formControlIndex:questionIdToFormIndex | additionalInfoName"
                  [name]="question.id | formControlIndex:questionIdToFormIndex | additionalInfoName"
                  [placeholder]="getAdditionalInformationLabel(question)" [rows]="5" [maxlength]="2000">
                </lds-text-area>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!editMode">
            <div class="row">
              <div class="col">
                <div class="row" *ngFor="let choice of question | selectedChoices">
                  <div class="col">{{choice}}</div>
                </div>

                <div *ngIf="question | showAdditionalInfo" class="row question__additional-information">
                  <div class="col">{{ question.answer?.additionalInformation | additionalInfoDisplay }}</div>
                </div>
              </div>
              <ng-container *ngIf="hasViolation(question.id)">
                <div class="col-auto">
                  <lds-icon name="warning" appearance="warning"></lds-icon>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </lds-card>
  </ng-template>
</form>